export default __webpack_public_path__ + "static/kenya_map-8a0867fb8b36fe3ff7b96bbb24f6828e.svg";